import {List, Map} from "immutable";
import React, {Fragment, useState} from "react";
import Arrow from "../../components/shared/icons/Arrow";
import {StatusWithIcon} from "../../components/shared/StatusWithIcon";
import {TrackingStatus} from "../../components/shared/TrackingStatus";
import {cx} from "../../lib/ClassSet";
import {formatFulfillmentStatus} from "../../lib/FulfillmentStatus";
import {fromUTCString, simpleDateFormat} from "../../lib/DateFormatter";
import ContextMenuTrigger from "../../components/ContextMenuTrigger";
import Checkbox from "../../components/Checkbox";
import CountBubble from "../../components/CountBubble";
import Conditional from "../../components/Conditional";
import {Link} from "react-router";
import TrackingNr from "../../components/TrackingNr";
import Table from "../../components/Table";
import styles from "./PackageTrackingItemMulti.module.scss";

export default function PackageTrackingItemMulti(props) {
  const { data } = props;
  const [expanded, setExpanded] = useState(false);
  
  function handleToggle() {
    setExpanded(!expanded);
  }

  function handleDownloadLabel(trackingNr, e, field = "") {
    e.stopPropagation();
    if (field === "label") {
      props.onDownloadShippingLabel(trackingNr);
    }
  }

  const classes = cx({
    [styles.module]: true,
    [styles.expanded]: expanded,
    [styles.contracted]: !expanded,
  });


  let replacedPackagesMap = props.replacedPackageIds.reduce((acc, r) => {
    return acc.set(r.get("packageId"), r);
  }, Map());
  let replacedPackageIds = props.replacedPackageIds.map(r => r.get("packageId"));

  const contextClickFn = (x, y) => props.onContextMenuClick(data, x, y)

  let allPackageIds = data.get("packages").map(p => p.get("packageId")).toSet();

  return (
    <div className={classes}>
      <div className={styles.header} onClick={handleToggle}>
        <div className={styles.trackingNrField}>{trackingNumber(data, props.courierId, expanded)}</div>
        <CountBubble count={data.get("packages").size} />
        <div className={styles.headerField}>{trackingStatus(data.get("tracking"), allPackageIds, replacedPackageIds)}</div>
        <div className={styles.headerField}>{status(data.get("status"), allPackageIds, replacedPackageIds)}</div>
        <div className={styles.headerField}>
          Last updated: {lastStatusDate(data)}
        </div>
        <Conditional show={data.get("pickupDate") !== ""}>
          <div className={styles.headerField}>
            Pickup: {data.get("pickupDate")}
          </div>
        </Conditional>  
        <Conditional show={data.get("voidDate") !== ""}>
          <div className={styles.headerField}>
            Voided: {data.get("voidDate")}
          </div>
        </Conditional>  
        <div className={styles.headerStretchField} />
        <div className={styles.headerActionsField}>
          <ContextMenuTrigger active={true} onClick={contextClickFn}/>
          <Checkbox
            active={true}
            onClick={() => props.areChecked(allPackageIds) ? props.toggleOff(allPackageIds) : props.toggleOn(allPackageIds)}
            checked={props.areChecked(allPackageIds)}
            noMargin={true}
            />
        </div>
      </div>
      <div className={styles.packages}>
        <PackagesList 
          packages={data.get("packages")} 
          hasShippingLabels={props.hasShippingLabels} 
          replacedPackagesMap={replacedPackagesMap} 
          replacedPackageIds={replacedPackageIds} 
          isChecked={props.isChecked}
          onToggleChecked={props.onToggleChecked}
          onContextMenuClick={contextClickFn} 
          onDownloadLabel={handleDownloadLabel} />
      </div>
      <div className={styles.content}>
        <HistoryList data={data} useShipmentTracking={props.useShipmentTracking} />
      </div>      
    </div>
  )
}


function PackagesList({ packages, hasShippingLabels, replacedPackagesMap, replacedPackageIds, onContextMenuClick, isChecked, onToggleChecked, onDownloadLabel }) {

  const tableHeader = List([
    "Pkg. Id",
    "Dimensions",
    "Inventory",
    "Label",
    "", // actions defined in listing
  ]);


  // let elements = 

  return (
    <section className={styles.packagesSection}>
      <div className={styles.sectionTitle}>Packages bundled in parcel</div>
      <div className={styles.sectionInner}>
        <Table
          data={packages}
          renderer={MultiItem}
          extraClassName={styles.packagesListTable}
          itemKey="packageId"
          mode="list"
          rendererParams={{
            hasShippingLabels: hasShippingLabels,
            replacedPackageIds: replacedPackageIds,
            replacedPackagesMap: replacedPackagesMap,
            onContextMenuClick: onContextMenuClick,
            isChecked: isChecked,
            onToggleChecked: onToggleChecked,
            onDownloadLabel: onDownloadLabel,
          }}
          />
      </div>
    </section>
  )
}

function MultiItem({data, hasShippingLabels, replacedPackagesMap, onContextMenuClick, isChecked, onToggleChecked, onDownloadLabel}) {
  let hasReplacement = replacedPackagesMap.has(data.get("packageId"));
  return (
    <li className={styles.trackingItem}>
      <div className={styles.trackingItemPackageId}>{data.get("packageId")}</div>
      <div className={styles.trackingItemDimensions}>
        {data.get("dimensions")}, {data.get("weight")}
      </div>
      <div className={styles.trackingItemInventory}>
        {data.getIn(["inventory"]).map(i => <div key={i.get("sku")}>{i.get("title")} ({i.get("sku")})</div>)}
        {data.getIn(["packaging"]).map(i => <div key={i.get("sku")}>{i.get("title")} ({i.get("sku")})</div>)}
        <Conditional show={hasReplacement}>
          <span className={styles.replacedPackageNote}>
            This package was replaced by
            <Link to={`/shipping/orders/${replacedPackagesMap.getIn([data.get("packageId"), "replacementOrderId"])}`}>
              {replacedPackagesMap.getIn([data.get("packageId"), "replacementOrderId"])}
            </Link>
          </span>
        </Conditional>
      </div>
      <div className={styles.trackingItemLabel}>{labelDownload(data.get("trackingNr"), hasShippingLabels, onDownloadLabel)}</div>
      <div className={styles.trackingItemActions}>
        <Checkbox
          active={true}
          onClick={() => onToggleChecked(data.get("packageId"))}
          checked={isChecked(data.get("packageId"))}
          noMargin={true}
        />
      </div>
    </li>
  )
}

function HistoryList({ data, useShipmentTracking }) {
  let history = getHistory(data, useShipmentTracking);
  if (history.size === 0) {
    return (
      <section className={styles.historySection}>
        <div className={styles.sectionTitle}>No tracking activities found</div>
      </section>
    )
  }

  let historyElements = history.map(x => {
    return (
      <tr className="activity" key={`${x.get("date")}-${x.get("time")}`}>
        <td className="datetime">{x.get("date")} @ {x.get("time")}</td>
        <td>{formatFulfillmentStatus(x.get("status"))}</td>
        <td>{x.get("description")}</td>
        <td>{x.get("location")}</td>
      </tr>
    )
  });

  return (
    <section className={styles.historySection}>
      <div className={styles.sectionTitle}>Tracking Activity</div>
      <div className={styles.sectionInner}>
        <table className={styles.historyTable}>
          <thead>
            <tr>
              <td>Date & Time</td>
              <td>Status</td>
              <td>Observations</td>
              <td>Location</td>
            </tr>
          </thead>
          <tbody>
            {historyElements}
          </tbody>
        </table>
      </div>
    </section>
  )
}

function getHistory(data, useShipmentTracking) {
  const history = useShipmentTracking
    ? data.get("activity") // ups
    : data.get("history");
  
  if (history) {
    return history.reverse();
  }
  
  return List();
}

function trackingNumber(data, courierId, expanded) {
  const iconsCommonProps = {
    arrowStyle: Arrow.STYLES.DROP,
    colorDisabled: "var(--grey-900)"
  }
  const icon = expanded
    ? <Arrow {...iconsCommonProps} direction={Arrow.DIRECTIONS.DOWN} />
    : <Arrow {...iconsCommonProps} direction={Arrow.DIRECTIONS.RIGHT} />;

  return <>{ icon }<TrackingNr trackingNr={data.get("trackingNr")} trackingUrl={data.get("trackingUrl", "")} courierId={courierId} /></>;
}

function status(status, allPackageIds, replacedPackageIds) {
  let allReplaced = allPackageIds.every((id) => replacedPackageIds.includes(id));
  const displayedStatus = allReplaced ? "Replaced" : status;
  return <StatusWithIcon status={displayedStatus} />;
}

function lastStatusDate(data) {
  return formatUTCDateString(data.get("updatedAt"));
}

function trackingStatus(trackingStatus, allPackageIds, replacedPackageIds) {
  let allReplaced = allPackageIds.every((id) => replacedPackageIds.includes(id));
  const displayedStatus = allReplaced ? "completed" : trackingStatus;
  return <TrackingStatus status={displayedStatus} />;
}

function labelDownload(trackingNr, hasShippingLabels, onClickHandler) {
  if (!hasShippingLabels) return null;
  return <span className={styles.pdfIcon} name="Download label" onClick={(e) => onClickHandler(trackingNr, e, "label")}></span>
}

function formatUTCDateString(string) {
  const dateOrError = fromUTCString(string);

  return dateOrError.getMonth ? simpleDateFormat(dateOrError) : "--";
}